import api from './api';

export interface CVTemplate {
  id: number;
  category: string;
  value: string;
  label?: string;
  image_url?: string;
  display_order: number;
  is_active: boolean;
}

export interface GroupedTemplates {
  [category: string]: CVTemplate[];
}

// Cache for category images
const categoryImagesCache: { [category: string]: { [value: string]: string | null } } = {};

const cvTemplateService = {
  // Get all templates grouped by category
  async getGroupedTemplates(): Promise<GroupedTemplates> {
    try {
      const response = await api.get('/cv-templates?grouped=true');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Error fetching grouped templates:', error);
      return {};
    }
  },

  // Get templates for a specific category
  async getTemplatesByCategory(category: string): Promise<CVTemplate[]> {
    try {
      const response = await api.get(`/cv-templates/category/${category}`);
      return response.data.data || response.data || [];
    } catch (error) {
      console.error(`Error fetching templates for category ${category}:`, error);
      return [];
    }
  },

  // Get category images mapping (value -> image_url)
  async getCategoryImages(category: string): Promise<{ [value: string]: string | null }> {
    // Return from cache if available
    if (categoryImagesCache[category]) {
      return categoryImagesCache[category];
    }

    try {
      const response = await api.get(`/cv-templates/category/${category}/images`);
      const images = response.data.data || response.data || {};
      // Cache the result
      categoryImagesCache[category] = images;
      return images;
    } catch (error) {
      console.error(`Error fetching images for category ${category}:`, error);
      return {};
    }
  },

  // Get a specific category image by value
  async getCategoryImageUrl(category: string, value: string): Promise<string | null> {
    const images = await this.getCategoryImages(category);
    return images[value] || null;
  },

  // Clear the cache (useful when images are updated)
  clearCache() {
    Object.keys(categoryImagesCache).forEach(key => {
      delete categoryImagesCache[key];
    });
  }
};

export default cvTemplateService;




